import React from 'react'
import { NavLink } from 'react-router-dom'

import { SUPER_ADMIN } from 'app/constants/roles'
import Spinner from 'app/components/Spinner/Spinner'

import './styles.scss'

export const bc = 'logo'

const MainLogo = ({ organization, roleName }) => {
  if (roleName === SUPER_ADMIN) {
    return (
      <NavLink to="/" className={bc}>
        Pro<span className={`${bc}__accent`}>Habits</span>
      </NavLink>
    )
  }
  if (organization && organization.get('logo')) {
    return (
      <NavLink to="/" className={`${bc} ${bc}--with-image`}>
        <img className={`${bc}__img`} src={organization.get('logo')} alt={organization.get('name')} />
      </NavLink>
    )
  }
  return (
    <div className={`${bc}__placeholder`}>
      <Spinner transparent />
    </div>
  )
}

export default MainLogo
